import axioInstance from "@/libs/axios";
import { QuotePayload } from "@/types/quote/quote-data";

// const baseURL = "http://localhost:3000/api";
const updateQuoteReference = async (payload: QuotePayload) => {
  let quoteResponse: QuotePayload | null;

  const result = await axioInstance.patch(
    `/quote/${payload.referenceId}/initialQuestionSet`,
    {
      data: payload,
    }
  );

  quoteResponse = result?.data?.data;
  return quoteResponse;
};

export default updateQuoteReference;
